
import notification from './notification';
import constantsValid from './constantsValid';
import errorMesseage from './errorMesseage';

const manageVideo = {notification, constantsValid, errorMesseage};

export default manageVideo;